import type { BranchNodeData } from './buildGraph';
import { HoverShell } from './HoverShell';

/** Hover de sucursal (sección 7.2 del spec): resumen agregado de sus nodos. */
export function BranchHoverCard({ data, x, y }: { data: BranchNodeData; x: number; y: number }) {
  const withAlerts = data.criticalCount + data.warningCount;
  return (
    <HoverShell x={x} y={y}>
      <div className="font-semibold tracking-tight">{data.label}</div>
      <div className="opacity-70">
        {data.onlineCount}/{data.totalCount} online
      </div>
      {withAlerts > 0 && (
        <div className="opacity-70">
          {withAlerts} con alerta
          {data.criticalCount > 0
            ? `: ${data.criticalCount} crítica${data.criticalCount > 1 ? 's' : ''}`
            : ''}
          {data.warningCount > 0
            ? `${data.criticalCount > 0 ? ', ' : ': '}${data.warningCount} warning`
            : ''}
        </div>
      )}
      {data.worstAliases.length > 0 && (
        <div className="opacity-60">{data.worstAliases.join(', ')}</div>
      )}
    </HoverShell>
  );
}
